'use strict';
document.addEventListener('DOMContentLoaded', function () {

let worksData = [
  {
    cat: 'graphic',
    tit: 'ロゴマーク',
    img: '62',
    cli: '全国がんセンター協議会',
    url: ''
  },
  {
    cat: 'web',
    tit: 'オフィシャルサイト',
    img: '61',
    cli: '全国がんセンター協議会',
    url: 'https://www.zengankyo.jp/'
  },
  {
    cat: 'web',
    tit: 'コーポレートサイト',
    img: '60',
    cli: '(株)日本水工コンサルタント',
    url: 'https://www.nissuiko.co.jp/'
  },
  {
    cat: 'web',
    tit: 'オフィシャルサイト',
    img: '59',
    cli: '公益財団法人 豊田理化学研究所',
    url: 'https://www.toyotariken.jp/'
  },
  {
    cat: 'graphic',
    tit: 'ロゴマーク',
    img: '58',
    cli: 'クリエイティブ・リンク・ナゴヤ',
    url: ''
  },
  {
    cat: 'web',
    tit: 'オフィシャルサイト',
    img: '57',
    cli: 'クリエイティブ・リンク・ナゴヤ',
    url: 'https://creative-link-nagoya.jp/'
  },
  {
    cat: 'web',
    tit: 'コーポレートサイト',
    img: '56',
    cli: '(株)TBエンジニアリング',
    url: 'https://www.tb-eng.co.jp/'
  },
  {
    cat: 'web',
    tit: 'コーポレートサイト',
    img: '55',
    cli: '中日本建設コンサルタント(株)',
    url: 'https://www.nakanihon.co.jp/'
  },
  {
    cat: 'graphic',
    tit: '日本ガイシ・リコー合弁会社 ロゴマーク',
    img: '53',
    cli: 'NR-Power Lab',
    url: ''
  },
  {
    cat: 'web',
    tit: '日本ガイシ・リコー合弁会社 コーポレートサイト',
    img: '52',
    cli: 'NR-Power Lab',
    url: 'https://www.nr-power-lab.jp/'
  }, 
  {
    cat: 'web',
    tit: 'オフィシャルサイト',
    img: '51',
    cli: 'トヨタ産業技術記念館',
    url: 'https://www.tcmit.org/'
  }, 
  {
    cat: 'other',
    tit: 'クラブハウス外壁・受付銘板・サイン',
    img: '50',
    cli: '諸の木テニス倶楽部',
    url: ''
  }, 
  {
    cat: 'graphic',
    tit: ' ロゴマーク',
    img: '49',
    cli: '諸の木テニス倶楽部',
    url: ''
  }, 
  {
    cat: 'web',
    tit: 'オフィシャルサイト',
    img: '54',
    cli: '諸の木テニス倶楽部',
    url: 'https://www.moronoki.com/'
  }, 
  {
    cat: 'web',
    tit: 'オフィシャルサイト',
    img: '17',
    cli: '養老公園',
    url: 'https://www.yoro-park.com/'
  },
  {
    cat: 'web',
    tit: 'コーポレートサイト',
    img: '48',
    cli: '(株)北陽',
    url: 'https://www.hokuyo-corp.jp/'
  },
  {
    cat: 'graphic',
    tit: '三祐コンサルタンツ 日経新聞広告',
    img: '47',
    cli: '(株)三祐コンサルタンツ',
    url: ''
  },
  {
    cat: 'web',
    tit: 'DRCT オフィシャルサイト',
    img: '46',
    cli: '一般社団法人 DRCT 災害復興協力チーム',
    url: 'http://drct.jp/'
  },
  {
    cat: 'other',
    tit: 'トヨタコレクション企画展 予告動画',
    img: '45',
    cli: 'トヨタ産業技術記念館',
    url: '',
    youtube: 'Q8IRAcmTo1U'
  },
  {
    cat: 'web',
    tit: 'オフィシャルサイト',
    img: '42',
    cli: 'トヨタ博物館',
    url: 'https://toyota-automobile-museum.jp/'
  },
  {
    cat: 'web',
    tit: '全国上下水道コンサルタント協会中部支部 オフィシャルサイト',
    img: '43',
    cli: '全国上下水道コンサルタント協会',
    url: 'https://www.suikon-chubu.jp/'
  },
  {
    cat: 'web',
    tit: 'JAGREE-ONLINE EXPOサイト',
    img: '44',
    cli: '農業土木事業協会',
    url: 'https://jagree-online.jp/'
  },
  {
    cat: 'web',
    tit: '諸の木テニスクラブ 採用サイト',
    img: '35',
    cli: 'エヌジーケイゆうサービス（株）',
    url: 'https://www.moronoki.com/recruit/'
  },
  {
    cat: 'web',
    tit: 'バーチャルガイドツアー',
    img: '37',
    cli: 'トヨタ産業技術記念館',
    url: 'https://www.tcmit.org/virtual-guided-tour/'
  },
  {
    cat: 'web',
    tit: 'コーポレートサイト',
    img: '36',
    cli: '（株）リバイブ',
    url: 'https://revive.inc/'
  },
  {
    cat: 'web',
    tit: 'コーポレートサイト',
    img: '34',
    cli: '名鉄コミュニティライフ（株）',
    url: 'https://www.meitetsu-cl.co.jp/'
  },
  {
    cat: 'graphic',
    tit: '諸の木テニスクラブ 施設案内パンフレット',
    img: '38',
    cli: 'エヌジーケイゆうサービス（株）',
    url: ''
  },
  {
    cat: 'graphic',
    tit: 'ロゴマーク＆ペーパーツール',
    img: '39',
    cli: '（株）リバイブ',
    url: ''
  },
  {
    cat: 'graphic',
    tit: 'ロゴマーク＆ペーパーツール',
    img: '40',
    cli: '（株）SP',
    url: ''
  },
  {
    cat: 'other',
    tit: '各種サイン',
    img: '41',
    cli: '（株）リバイブ',
    url: ''
  },
  {
    cat: 'web',
    tit: '日本ガイシグループ会社様用 コーポレートテンプレート',
    img: '28',
    cli: '日本ガイシ(株)',
    url: ''
  },
  {
    cat: 'web',
    tit: 'クロスオフィス ポータルサイト',
    img: '29',
    cli: 'オリックス（株）',
    url: 'https://www.crossoffice.jp/'
  },
  {
    cat: 'web',
    tit: 'コーポレートサイト',
    img: '30',
    cli: '山崎情報設計 (株)',
    url: 'https://iday.co.jp/'
  },
  {
    cat: 'web',
    tit: 'コーポレートサイト',
    img: '31',
    cli: '(株)豊田中央研究所',
    url: 'https://www.tytlabs.co.jp/'
  },
  {
    cat: 'web',
    tit: 'サービスサイト',
    img: '32',
    cli: '東海東京証券(株)',
    url: 'http://www.tokaitokyo.co.jp/'
  },
  {
    cat: 'web',
    tit: 'コーポレートサイト',
    img: '33',
    cli: '(株)東郷製作所',
    url: 'http://www.togoh.co.jp/'
  },
  {
    cat: 'graphic',
    tit: '製品案内 パンフレット',
    img: '21',
    cli: '日本ガイシ(株)',
    url: ''
  },
  {
    cat: 'graphic',
    tit: '会社案内 パンフレット',
    img: '22',
    cli: '(株)TBエンジニアリング',
    url: ''
  },
  {
    cat: 'graphic',
    tit: '社内報「シャトル」',
    img: '23',
    cli: 'トヨタ紡織(株)',
    url: ''
  },
  {
    cat: 'graphic',
    tit: 'まごころ解体現場配慮図',
    img: '24',
    cli: '(株)リバイブ',
    url: ''
  },
  {
    cat: 'graphic',
    tit: '採用案内 パンフレット',
    img: '25',
    cli: '(株)三祐コンサルタンツ',
    url: ''
  },
  {
    cat: 'graphic',
    tit: 'ロゴマーク',
    img: '26',
    cli: '山崎情報設計(株)',
    url: ''
  },
  {
    cat: 'graphic',
    tit: 'ロゴマーク',
    img: '27',
    cli: '養老公園',
    url: ''
  },
  {
    cat: 'web',
    tit: 'コーポレートサイト',
    img: '18',
    cli: 'イビデングリーンテック(株）',
    url: 'https://www.ibiden-greentec.co.jp/'
  },
  {
    cat: 'web',
    tit: '新卒採用サイト',
    img: '19',
    cli: '日本ガイシ(株)',
    url: 'https://www.ngk.co.jp/recruit/university/'
  },
  {
    cat: 'web',
    tit: 'キャリア採用サイト',
    img: '20',
    cli: '日本ガイシ(株)',
    url: 'https://www.ngk.co.jp/recruit/career/'
  },
  {
    cat: 'web',
    tit: 'コンセプトスペシャルサイト',
    img: '2',
    cli: '(株）アグメント',
    url: 'https://agument.co.jp/special/'
  },
  {
    cat: 'web',
    tit: 'クロスオフィス新宿 オフィシャルサイト',
    img: '3',
    cli: 'オリックス（株）',
    url: 'https://www.crossoffice.jp/sjk/'
  },
  {
    cat: 'web',
    tit: 'コーポレートサイト',
    img: '4',
    cli: '(株)コンポン研究所',
    url: 'https://www.konpon.com/'
  },
  {
    cat: 'web',
    tit: 'バーチャル展示室',
    img: '6',
    cli: 'トヨタ産業技術記念館',
    url: 'https://www.tcmit.org/360virtual/'
  },
  {
    cat: 'web',
    tit: 'オフィシャルサイト',
    img: '7',
    cli: 'トヨタ紡織 (株)',
    url: 'https://www.tb-athlete.jp/basket/'
  },
  {
    cat: 'web',
    tit: '50周年記念サイト',
    img: '8',
    cli: '(株)三祐コンサルタンツ',
    url: 'http://sanyu-anniversary.jp/'
  },
  {
    cat: 'web',
    tit: '採用サイト',
    img: '9',
    cli: '(株)三祐コンサルタンツ',
    url: 'https://sanyu-recruit.jp/'
  },
  {
    cat: 'web',
    tit: '全国水土里ネット ふるさとの田んぼと水 子ども絵画展サイト',
    img: '11',
    cli: 'アグリネクストジャパン',
    url: 'http://agrinext.jp/kidsmuseum/'
  },
  {
    cat: 'web',
    tit: '大榮産業食品製造部門 オフイシャルサイト',
    img: '13',
    cli: '大榮産業(株)',
    url: 'http://www.daiei-sangyo.co.jp/department/food/'
  },
  {
    cat: 'web',
    tit: 'サービスサイトエムコミュニティ',
    img: '14',
    cli: '名鉄コミュニティライフ(株)',
    url: 'https://www.meitetsu-cl.com/'
  },
  {
    cat: 'web',
    tit: 'オフィシャルサイト',
    img: '15',
    cli: '水土里ネット明治用水',
    url: 'http://www.midorinet-meiji.jp/'
  },
  {
    cat: 'web',
    tit: '明治用水土地改良区 eラーニングサイト',
    img: '16',
    cli: '水土里ネット明治用水',
    url: 'http://www.midorinet-meiji.jp/e-learning/'
  },
]


let worksContentWrap = document.querySelector('.works-content_wrap');
let worksContentItem = '';

worksData.forEach(function(work, index) {

  worksContentItem += `
    <div class="works-content_item" data-category="${work.cat}" data-number="${index}">
      <figure class="works-content_item_thumb">
        <img src="/_/media/page/works/img-works-${work.img}-thumb.jpg" class="works-content_item_thumb_image" alt="">
        <span class="works-content_item_thumb_client">${work.cli}</span>
        <span class="works-content_item_thumb_tag">${work.tit}</span>
      </figure>
    </div>
  `;
});


worksContentWrap.innerHTML = worksContentItem;

let worksCategoryItems = document.querySelectorAll('.works-category_item');
let allItems = document.querySelectorAll('[data-category]');
let worksContent = document.querySelector('.works-content');

worksCategoryItems.forEach(function(category) {
  category.addEventListener('click', function() {
    let self = this; // 'this' を 'self' に保存
    worksContent.style.opacity = 0;

    setTimeout(function() {
      // すべてのカテゴリー項目から 'is-current' クラスを削除
      worksCategoryItems.forEach(function(item) {
        item.classList.remove('is-current');
      });

      // クリックされた項目に 'is-current' クラスを追加
      self.classList.add('is-current');

      // クリックされた項目の data-works-category 値を取得
      let currentCategory = self.getAttribute('data-works-category');

      // すべてのアイテムをループ処理し、表示・非表示を切り替え
      allItems.forEach(function(item) {
        if (currentCategory === 'all') {
          item.style.display = ''; // 'all' が選択された場合、すべての項目を表示
        } else {
          // 'all' 以外が選択された場合、条件に一致する項目のみを表示
          if (item.getAttribute('data-category') === currentCategory) {
            item.style.display = ''; // 同じカテゴリの項目を表示
          } else {
            item.style.display = 'none'; // それ以外の項目を非表示
          }
        }
      });

      worksContent.style.opacity = 1;
    }, 200); // 0.3秒（300ミリ秒）の遅延を設定

  });
});

//
document.querySelectorAll('.works-content_item').forEach(item => {
  item.addEventListener('click', function(event) {
    let clickedItemNumber = this.getAttribute('data-number');

    let modalHtmlUrl = '';
    if ( worksData[clickedItemNumber].url ) {
      modalHtmlUrl = `
        <div class="works-modal_content_wrap">
          <dt class="works-modal_content_desc_term">WEBSITE</dt>
          <dd class="works-modal_content_desc_val"><a href="${worksData[clickedItemNumber].url}" target="_blank">${worksData[clickedItemNumber].url} <span class="icon-popup"></span></a></dd>
        </div>
      `;
    }

    let modalHtmlVisual = '';
    if ( worksData[clickedItemNumber].youtube ) {
      modalHtmlVisual = `
        <div class="works-modal_content_youtube">
          <div class="works-modal_content_youtube_container">
            <iframe src="https://www.youtube.com/embed/${worksData[clickedItemNumber].youtube}?playsinline=1&amp;rel=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>
          </div>
        </div>

      `;
    } else {
      modalHtmlVisual = `<div class="works-modal_content_image"><img src="/_/media/page/works/img-works-${worksData[clickedItemNumber].img}-full.jpg" class="works-modal_content_image_item" alt=""></div>`;
    }

    const modalHtml = `
      <div class="works-modal">
        <button class="works-modal_close">✕</button>
        <div class="works-modal_content">
          ${modalHtmlVisual}
          <p class="works-modal_content_tag">${worksData[clickedItemNumber].tit}</p>
          <dl class="works-modal_content_desc">
            <div class="works-modal_content_wrap">
              <dt class="works-modal_content_desc_term">CLIENT</dt>
              <dd class="works-modal_content_desc_val">${worksData[clickedItemNumber].cli}</dd>
            </div>
            ${modalHtmlUrl}
          </dl>
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML('beforeend', modalHtml);
    setTimeout(function() {
      document.querySelector('.works-modal').classList.add('is-show');
    }, 3); // 3ミリ秒の遅延

    // モーダルの中にあるクローズボタンにイベントリスナーを追加
    let worksModalClose = document.querySelector('.works-modal_close');
    worksModalClose.addEventListener('click', function() {
      let worksModal = document.querySelector('.works-modal');
      worksModal.parentNode.removeChild(worksModal);
    });
  });
});

let worksModalClose = document.querySelector('.works-modal_close');

worksModalClose.addEventListener('click', function(event) {
});


});
